import { render, staticRenderFns } from "./ProfileIndexPage.vue?vue&type=template&id=3026f64d"
import script from "./ProfileIndexPage.vue?vue&type=script&lang=ts"
export * from "./ProfileIndexPage.vue?vue&type=script&lang=ts"
import style0 from "./ProfileIndexPage.vue?vue&type=style&index=0&id=3026f64d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports